<template>
  <div class="stat-card" :style="{ '--card-color': color }">
    <div class="stat-header">
      <div class="stat-icon">
        <i class="bi" :class="`bi-${icon}`"></i>
      </div>
      <h3 class="stat-title">{{ title }}</h3>
    </div>
    
    <div class="stat-content">
      <div class="stat-value">{{ value }}</div>
      <div v-if="trend" class="stat-trend">{{ trend }}</div>
    </div>
    
    <div class="stat-footer">
      <div class="stat-progress">
        <div class="progress-bar" :style="{ width: '100%' }"></div>
      </div>
    </div>
  </div>
</template>

<script setup>
//eslint-disable-next-line
defineProps({
  title: String,
  value: [String, Number],
  icon: String,
  color: {
    type: String,
    default: '#b71c1c'
  },
  trend: String
});
</script>

<style scoped>
.stat-card {
  background: white;
  border-radius: 16px;
  padding: 1.5rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
  border: 1px solid #eaeaea;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.stat-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: var(--card-color);
  border-radius: 16px 16px 0 0;
}

.stat-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);
}

.stat-header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1rem;
}

.stat-icon {
  width: 40px;
  height: 40px;
  background: linear-gradient(135deg, var(--card-color), color-mix(in srgb, var(--card-color) 80%, white));
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.2rem;
}

.stat-title {
  font-size: 0.9rem;
  color: #666;
  margin: 0;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.stat-content {
  margin-bottom: 1rem;
}

.stat-value {
  font-size: 2rem;
  font-weight: 700;
  color: #333;
  line-height: 1;
  margin-bottom: 0.5rem;
}

.stat-trend {
  font-size: 0.85rem;
  color: #4caf50;
  font-weight: 500;
}

.stat-footer {
  padding-top: 1rem;
  border-top: 1px solid #f0f0f0;
}

.stat-progress {
  height: 4px;
  background: #f0f0f0;
  border-radius: 2px;
  overflow: hidden;
}

.progress-bar {
  height: 100%;
  background: linear-gradient(90deg, var(--card-color), color-mix(in srgb, var(--card-color) 70%, white));
  border-radius: 2px;
  transition: width 1s ease;
}
</style>